/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Didntreceiveemail2Inputs */

const en_didntreceiveemail2 = /** @type {(inputs: Didntreceiveemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didn't receive the email?`)
};

const de_didntreceiveemail2 = /** @type {(inputs: Didntreceiveemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail nicht erhalten?`)
};

/**
* | output |
* | --- |
* | "Didn't receive the email?" |
*
* @param {Didntreceiveemail2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const didntreceiveemail2 = /** @type {((inputs?: Didntreceiveemail2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Didntreceiveemail2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_didntreceiveemail2(inputs)
	return de_didntreceiveemail2(inputs)
});
export { didntreceiveemail2 as "didntReceiveEmail" }